import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IApp } from '@core/models/app.interfaces';
import IDocument = IApp.IDocument;
import { Dialog, DialogModule } from 'primeng/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DocumentsComponent } from '@shared/components/documents/documents.component';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-complimentary-compliance-report-additional-details',
  templateUrl: './complimentary-compliance-report-additional-details.component.html',
  styleUrls: ['./complimentary-compliance-report-additional-details.component.scss'],
  imports: [TranslateModule, DialogModule, DocumentsComponent, CommonModule, FormlyModule,
    ReactiveFormsModule]
})
export class ComplimentaryComplianceReportAdditionalDetailsComponent implements OnInit, AfterViewInit {

  @ViewChild('dialog', { static: false }) dialog: Dialog;

  public currentStepObj;
  public visible = true;
  public documents: IDocument[];
  public isDocumentUploadInProgress = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<ComplimentaryComplianceReportAdditionalDetailsComponent>,
  ) { }

  ngOnInit() {
    this.currentStepObj = this.data.currentStepObj;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.currentStepObj.additionalDetailsForm.disable();
    });
  }

  documentUploadHandler(documentResult: IApp.IEmmitedDocs): void {
    this.documents = documentResult.docs;
    this.isDocumentUploadInProgress = documentResult.docs
      .filter(document => document._uploadStatus)
      .some(document => document._uploadStatus !== 'CLEAN');
  }

  public close(): void {
    this.dialogRef.close(false);
  }

  scrollToTop(): void {
    setTimeout(() => {
      this.dialog.el.nativeElement.querySelector('.p-dialog-content').scrollTo(0, 0);
    }, 500);
  }

}
